module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAElBMVEUAAAB3d3d4eHh3d3d3d3d4eHjlFVw2AAAABXRSTlMAYJ9AIMQVYbIAAABkSURBVHjatcq3AcMwDABBkgD2X9lW/O6Vr772pTxxevUTp1hyWHJYclhyWHJYclhyWHJYdlh2WH5YHF0cX1Eu5jX0jNZkcWRxZHFkcWxxWHZYdlh2WHZYdlh2WHZYdlgc0dstP6hiCcsBkFdmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/paramIcon/实心菱形.png
// module id = mPOV
// module chunks = 2